import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { MemberDetail } from "./member-detail.model";

@Injectable({
  providedIn: "root",
})
export class MemberStateService {
    state = new BehaviorSubject<MemberDetail>(new MemberDetail());

    setData(data: Partial<MemberDetail>): void {
      const newData = new MemberDetail({ ...this.state.value, ...data });
      this.state.next(newData);
    }

    clearData(): void {
      this.state.next(new MemberDetail());
    }
}
